export const deliveryCost = {
  'PBM': [0, 17.5],
  'CM': [50, 100],  
  'WN': ['De leverkosten in Wanica worden in overleg bepaald. Wij nemen contact met u op na het plaatsen van uw bestelling.','De leverkosten in Wanica worden in overleg bepaald. Wij nemen contact met u op na het plaatsen van uw bestelling.'],
  'PR': [100, 150],
  'BR': [100, 150],
  'OO': [0, 0]
}

export const deliveryDivider = {
  'PBM': 0,
  'CM': 500,  
  'WN': 500,
  'PR': 500,
  'BR': 500,
  'OO': [0, 0]
}

export const deliveryRules = {
  'PBM': 'Leveringen binnen Paramaribo zijn gratis in december.',
  'CM': 'De leverkosten in Commewijne worden in overleg bepaald. Wij nemen contact met u op na het plaatsen van uw bestelling.',  
  'WN': 'De leverkosten in Wanica worden in overleg bepaald. Wij nemen contact met u op na het plaatsen van uw bestelling.',
  'PR': 'De leverkosten in Para worden in overleg bepaald. Wij nemen contact met u op na het plaatsen van uw bestelling.',
  'BR': 'De leverkosten in Brokopondo worden in overleg bepaald. Wij nemen contact met u op na het plaatsen van uw bestelling.',
  'OO': 0
}

// export const deliveryCost = {
//   'PBM': [0, 17.5],
//   'CM': [50, 100],  
//   'WN': [50,100],
//   'PR': [100, 150],
//   'BR': [100, 150],
//   'OO': [0, 0]
// }

// export const deliveryDivider = {
//   'PBM': 300,
//   'CM': 500,  
//   'WN': 500,
//   'PR': 500,
//   'BR': 500,
//   'OO': [0, 0]
// }

// export const deliveryRules = {
//   'PBM': 'Leveringen binnen Paramaribo boven SRD 300 zijn gratis. Minder dan SRD 300 zijn SRD 17,50',
//   'CM': 'Leverkosten binnen Commewijne boven SRD 500 zijn SRD 50. Minder dan SRD 500 zijn SRD 100',  
//   'WN': 'Leverkosten binnen Wanica boven SRD 500 zijn SRD 50. Minder dan SRD 500 zijn SRD 100',
//   'PR': 'Leverkosten binnen Para boven SRD 500 zijn SRD 100. Minder dan SRD 500 zijn SRD 150',
//   'BR': 'Leverkosten binnen Brokopondo boven SRD 500 zijn SRD 100. Minder dan SRD 500 zijn SRD 150',
//   'OO': 0
// }

